module.exports = __webpack_public_path__ + "static/media/exit_fullscreen.7bda3c35.svg";